import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Notifications from "../Notifications/Notifications";
import { decodeToken } from "../../config/auth";
import avatar from "../../assets/img/avatar.svg";
import arrowBack from "../../assets/img/arrow-back.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import CircleImage from "../Image/CircleImage/index";
import "./styles.scss";
import { useAuth } from "../../context/ContextApi";

function Layout(props) {
  const { userId } = useAuth();
  const [show, setShow] = useState(window.innerWidth <= 760 ? true : false);
  const [user, setUser] = useState({});

  const toggleShow = () => {
    setShow(!show);
  };

  useEffect(() => {
    if (userId) {
      const { user: session = {} } = decodeToken();
      setUser(session);
    }
  }, [userId]);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      <div className="wrapper d-flex h-100 overflow-hidden">
        <div className="d-flex flex-row w-100">
          <Sidebar show={show} defaultMenu={props.defaultMenu} />
          <div className="d-flex align-items-center flex-column w-100">
            <div className="w-100 mx-auto overflow-auto h-100 page-container">
              <nav className="navbar navbar-expand-lg navbar-light bg-light  mb-1 mt-0 mt-lg-4">
                {props.buttonClick && (
                  <button style={{ background: "#fff", fontSize: "32px" }} onClick={props.buttonClick}>
                    {" "}
                    &#8249;{" "}
                  </button>
                )}
                <div className="container-fluid px-lg-1">
                  <span className="navbar-brand d-flex d-lg-none w-100" onClick={() => toggleShow()}>
                    <FontAwesomeIcon icon={faBars} className="ms-1 mt-2" />
                  </span>
                  <div className="d-flex align-items-center">
                    {(props.link !== "") & (props.link !== undefined) & (props !== null) ? (
                      <a className="t-decoration-none d-flex align-items-center" href={props.link}>
                        <img className="me-1 me-lg-3" alt="" src={arrowBack} width={12} height={12} />
                      </a>
                    ) : (
                      <></>
                    )}
                    <span className="fz-24 ff-univanova-600 text-cl-black">{props.title}</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-end">
                    <div
                      onClick={() => (window.location.href = "/perfil")}
                      className={"d-flex justify-content-center align-items-center"}
                    >
                      <span className="fz-16 ff-univanova-600 text-cl-black c-pointer me-2">{user.name}</span>
                      <CircleImage
                        url={user.avatar !== undefined ? user.avatar : avatar}
                        sizePx={"40px"}
                        className={"c-pointer"}
                      />
                    </div>
                    <Notifications />

                    {/* <ul
                      className="dropdown-menu "
                      aria-labelledby="dropdownMenuReference"
                      style={{ borderRadius: "10px", right: "0", left: "66%" }}
                    >
                      <li
                        className="dropdown-header mx-3 px-0"
                        style={{ borderBottom: "2px solid #EAEAEA" }}
                      >
                        <label className=" fz-16 font-rubik fw-bold text-cl-black">
                          Notificações
                        </label>
                      </li>
                      <div className="notification-scroll mx-3 px-0 overflow-auto">
                        <NotificationItem
                          user="Bruna Garibaldi"
                          time="26 JAN 2022 11:01"
                        />
                      </div>
                      <li
                        className="dropdown-header d-flex justify-content-end mt-3  mx-3 px-0"
                        style={{ borderTop: "2px solid #EAEAEA" }}
                      >
                        <button className="btn br-6 button-white-primary border-auro-metal me-2">
                          Marcar todas como lidas
                        </button>
                        <button className="btn fz-16 btn-cl-red text-white ff-univanova-medium  ">
                          Limpar tudo
                        </button>
                      </li>
                    </ul> */}
                  </div>
                </div>
              </nav>
              <div onClick={() => setShow(false)}>{props.children}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade border-0"
        id="myModalAlertLogOut"
        tabIndex="-1"
        aria-labelledby="myModalAlertLogOutLabel"
        aria-hidden="true"
        style={{ borderRadius: "10px" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 p-4">
              <button
                type="button"
                id="btnCloseSingle"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="d-flex flex-column modal-body pt-0 px-5 pb-4">
              <span style={{ textAlign: "center" }} className="text-cl-black ff-univanova-bold fz-24">
                Você tem certeza que quer sair?
              </span>
              <span style={{ textAlign: "center" }} className="mt-3 d-flex text-cl-black ff-univanova-regular fz-14">
                Para retornar ao DASHBOARD, você precisará refazer o Login!
              </span>
              <div className="row my-3 mx-0">
                <div className="col-12 d-flex align-items-center justify-content-center px-0 mt-3">
                  <button
                    type="button"
                    className="btn br-6 button-white-primary border-auro-metal fz-16 me-3 px-4"
                    data-bs-dismiss="modal"
                  >
                    Voltar
                  </button>
                  <button type="submit" onClick={() => logout()} className="btn bg-gradient-theme-blue text-white px-4">
                    Sair do sistema
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
